import { AxiosError } from 'axios';
import { accountService } from '@app/services';
import { SetIsPasswordChanged, DataForPswResetSmsResponse, SetErrorMessage, SetPassword, SetIsError } from '@app/models';

export const handleChangePassword = (setPassword: SetPassword) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
};

export const onSubmitChangePassword =
    (
        userDataForChangePassword: DataForPswResetSmsResponse,
        newPassword: string,
        username: string,
        setIsPasswordChanged: SetIsPasswordChanged,
        setErrorMessage: SetErrorMessage,
        setIsError: SetIsError
    ) =>
    (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();

        accountService.changePassword(
            { ...userDataForChangePassword, newPassword, username },
            (error: AxiosError<any>) => {
                setIsError(true);
                setErrorMessage(error.response?.data?.message ?? '');
            },
            () => {
                setIsPasswordChanged(true);
            }
        );
    };
